import { LocaleSelectorPopover } from './LocaleSelectorPopover';
import { LocaleSwitcher } from './LocaleSwitcher';

export type LocaleSelectorWidgetProps = { showRegionPopup?: boolean };

export const LocaleSelectorWidget = ({ showRegionPopup }: LocaleSelectorWidgetProps) => {
    const selector = <LocaleSwitcher id="site-toggle-highlight" />;
    if (!showRegionPopup) {
        return selector;
    }

    return <LocaleSelectorPopover>{selector}</LocaleSelectorPopover>;
};
